import { oldKeys } from "./Keys.js";
import { isWord, protectedWordLength } from "./Words.js";

// placeholders
const openPlaceHolder = '\u203B';
const closePlaceHolder = '\u203B';

function findChords(inputText, method, open, close) {
	if (inputText === '') return '';

	switch (method) {
		case 'indent':
			return indentMethod(inputText, open, close);
		case 'pure':
			return pureMethod(inputText);
		default:
			return 'error'
	}
}

function indentMethod(text, openChar, closeChar) {
	let modifiedText = '';

	for (let i = 0; i < text.length; i++) {
		modifiedText += text[i];
		if (text[i] === openChar) {
			// end of text
			if (text[i + 1] === undefined) {
				return modifiedText += closePlaceHolder;
			}
			i++;

			// empty indent
			if (text[i] === closeChar) {
				modifiedText += text[i];
			} else {
				modifiedText += openPlaceHolder;

				while (text[i] !== closeChar) {
					if (text[i] === undefined) {
						return modifiedText += closePlaceHolder;
					}
					modifiedText += text[i];
					i++;
				}
				modifiedText += closePlaceHolder + text[i];
			}

		}
	}

	return modifiedText;
}

function pureMethod(text) {
	let modifiedText = '';
	for (let i = 0; i < text.length; i++) {
		const protectedLength = protectedWordLength(text, i);
		if (protectedLength > 0) {
			modifiedText += text.substr(i, protectedLength);
			i += protectedLength - 1;
		} else if (isKey(text[i]) && !isWord(text, i)) {
			modifiedText += openPlaceHolder + text[i];
			if (text[i + 1] === undefined) {
				return modifiedText += closePlaceHolder;
			}

			i++;
			while (!isWhitespace(text[i])) {
				if (text[i] === undefined) {
					return modifiedText += closePlaceHolder;
				}
				modifiedText += text[i];
				i++;
			}

			modifiedText += closePlaceHolder + text[i];
		} else {
			modifiedText += text[i];
		}
	}

	return modifiedText;
}

// Helper functions
function isWhitespace(char) {
	return char !== undefined && /\s/.test(char);
}

function isKey(char) {
	for (let i = 0; i < 12; i++) {
		if (char === oldKeys[i][0] || char === oldKeys[i][1]) {
			return true;
		}
	}
	return false;
}

export default findChords;